export default {
  optional: "أختيارى",
  minOrderValueInputHeader: "أقل قيمة للطلب",
  minOrderValueInputText: "قم بتفعيل اقل قيمة للطلب لتختار قيمة محددة له",
  minOrderValueText: "العملاء لايستطيعون عمل طلب بقيمة أقل من أقل قيمة للطلب.",
  minValue: "أٌقل قيمة",
};
